export default {"src":"/_next/static/media/PlayFilledSmooth.d26951a9.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};